import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import {
  flattenData,
  getDaysBetweenMonths,
  getDaysInMonth,
} from "../../../../Utilitie";
import * as echarts from "echarts";

const AvgMWPWITOHOGraph = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedFy,
}) => {
  const mon = new Date().toLocaleString("en-US", { month: "short" });

  const date = new Date().getDate() - 1;

  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("pwiAvgChart");
    let myChart = echarts.init(chartDom);

    const prevTotalTO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b = getDaysInMonth(
            `${Number(selectedFy.slice(0, 4)) - 1}_${Number(selectedFy.slice(7, 9)) - 1}`,
            month.slice(0, 3).toUpperCase(),
          );

          const d = getSectionData(m, s);
          return acc + Number(d.to_value || 0) / b;
        }, 0)
        .toFixed(1);
    });
    const currTotalTO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections
        .reduce((acc, s) => {
          const b =
            Number(selectedFy.slice(0, 4)) === new Date().getFullYear() &&
            month.slice(0, 3) === mon
              ? date
              : getDaysInMonth(
                  `${selectedFy.slice(0, 4)}_${selectedFy.slice(7, 9)}`,
                  month.slice(0, 3).toUpperCase(),
                );

          const d = getSectionData(m, s);
          return acc + Number(d.to_value || 0) / b;
        }, 0)
        .toFixed(1);
    });

    const option = {
      title: {
        text: `T/O – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1,
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: 30,
        data: [
          `T/O (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `T/O (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: `T/O (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `T/O (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currTotalTO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
      ],
    };

    myChart.setOption(option);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr]);

  return (
    <div>
      <div className="papaDiv">
        <div
          id="pwiAvgChart"
          style={{ width: "100%", height: "50vh", marginTop: "30px" }}
        ></div>
      </div>
    </div>
  );
};

export default AvgMWPWITOHOGraph;
